import React from 'react';
import CircularProgress from '@material-ui/core/CircularProgress';

import './loading.css';

const loading = <CircularProgress styleName="loading" />;

export default loading;
